//==================================================================================================
//  import
//==================================================================================================
import { Injectable } from '@angular/core';
import { Firestore, collection, onSnapshot, doc} from '@angular/fire/firestore';
import { Observable, Subscriber } from 'rxjs';

import { AppConst } from '../../../app-const';

import { FirePushmessage } from '../../../class/fire/pushmessage'

import { FirestoreUtil } from '../../../core/utility/firestore-util';
//==================================================================================================
//  Injectable
//==================================================================================================
@Injectable({
  providedIn: 'root'
})
//==================================================================================================
//
//==================================================================================================
export class PushmessageFireService {
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor(
    private firestore: Firestore) { }
  //================================================================================================
  //  プッシュメッセージ
  //================================================================================================
  getData(email: string): Observable<FirePushmessage> {
    const d = doc(this.firestore, AppConst.TABLE_PUSHMESSAGE, email);
    const observable = new Observable((subscriber: Subscriber<any>) => {
      onSnapshot(d ,(documentSnapshot) => {
        subscriber.next(FirestoreUtil.createDoc(documentSnapshot));
      });
    });
    return observable;
  }
}
